import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Countdown from "@/components/site/Countdown";
import Footer from "@/components/site/Footer";
import { About, Reasons } from "@/components/site/SectionsIntro";
import { Participants, Experiences, Expo, Exhibitors } from "@/components/site/Showcase";
import { Pricing, Future, Gallery, Venue, Faq } from "@/components/site/Engage";
import { BrochureProvider, ExitPopup, WhatsAppButton, useBrochureGate } from "@/components/site/Growth";
import { useSeo } from "@/lib/seo";

function StickyMobileCta() {
  return (
    <div data-testid="sticky-register-bar" className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between gap-3 border-t bg-[#f3f3e9]/95 px-4 py-3 backdrop-blur md:hidden" style={{ borderColor: "var(--line)" }}>
      <div className="text-[11px] font-extrabold leading-tight">
        <span className="badge-lime">EARLY BIRD</span>
        <span className="mt-1 block text-[#5c6b5a]">Delegate rates end 10 Nov 2026</span>
      </div>
      <Link to="/register" data-testid="sticky-register-btn" className="ofic-btn ofic-btn-forest !px-5 !py-2.5 text-[13px]">
        Register <span className="arrow">↗</span>
      </Link>
    </div>
  );
}

function HeroWithGate() {
  const brochure = useBrochureGate();
  return <Hero onBrochure={brochure} />;
}

export default function HomePage() {
  useSeo({
    title: "OFIC 2026 — Organic Food India Conclave | 11 Dec, Mumbai",
    description: "Join the Organic Food India Conclave 2026 — conference, exhibition, networking and awards. 11 December, Ginger Hotel, Mumbai. Early-bird registration open.",
  });
  return (
    <BrochureProvider>
      <Header />
      <main>
        <HeroWithGate />
        <Ticker />
        <Countdown />
        <About />
        <Reasons />
        <Participants />
        <Experiences />
        <Expo />
        <Exhibitors />
        <Pricing />
        <Future />
        <Gallery />
        <Venue />
        <Faq />
      </main>
      <Footer />
      <WhatsAppButton />
      <ExitPopup />
      <StickyMobileCta />
    </BrochureProvider>
  );
}
